import { ArrowUpRight } from "lucide-react";
import { Chapter, MaskedLines, Fade, Counter } from "./motion";

const STATS = [
    { value: 2, label: "Industry Certifications", note: "CREDENTIAL / VERIFIED" },
    { value: 2, label: "Practical Internships", note: "EXPERIENCE / ON-SITE" },
    { value: 1, label: "Published Technical Paper", note: "RESEARCH / PUBLISHED" },
    { value: 1, label: "Real-World Project", note: "BUILD / SHIPPED" },
];

export default function Outcomes() {
    return (
        <section className="bg-cobalt py-20 text-white md:py-40" data-testid="outcomes-section">
            <div className="mx-auto max-w-[1440px] px-6 md:px-10 lg:px-16">
                <Chapter index="CH.05" title="Outcomes" dark />

                <div className="mt-16 grid gap-10 md:mt-24 lg:grid-cols-12">
                    <div className="lg:col-span-8">
                        <MaskedLines
                            stagger={0.13}
                            lineClassName="font-display text-[clamp(2.2rem,7.5vw,5.4rem)] font-semibold leading-[1.12] tracking-[-0.02em] text-white"
                            lines={[
                                <span key="a">What four years</span>,
                                <span key="b" className="text-sky">compound into.</span>,
                            ]}
                        />
                    </div>
                    <div className="flex items-end lg:col-span-4">
                        <Fade delay={0.35}>
                            <p className="text-[11px] uppercase tracking-[0.3em] text-sky/80">
                                The QRUS graduation profile — per student
                            </p>
                        </Fade>
                    </div>
                </div>

                <div className="mt-16 grid md:mt-24 md:grid-cols-2 lg:grid-cols-4">
                    {STATS.map((stat, i) => (
                        <Fade
                            key={stat.label}
                            delay={0.1 + i * 0.1}
                            className={`border-white/20 px-2 py-10 md:px-8 md:py-14 ${
                                i > 0 ? "border-t md:border-l md:border-t-0" : ""
                            } ${i === 2 ? "md:border-l-0 lg:border-l" : ""} ${i > 1 ? "md:border-t lg:border-t-0" : ""}`}
                        >
                            <Counter
                                value={stat.value}
                                className="font-display text-[clamp(4.5rem,22vw,11rem)] font-extrabold leading-none tracking-tight text-white"
                            />
                            <p className="mt-6 max-w-[200px] text-sm font-medium uppercase tracking-[0.14em] text-white md:text-base">
                                {stat.label}
                            </p>
                            <p className="mt-2 text-[10px] uppercase tracking-[0.25em] text-sky/70">
                                {stat.note}
                            </p>
                        </Fade>
                    ))}
                </div>

                <Fade delay={0.3}>
                    <div className="group flex flex-col gap-6 border-t border-white/20 py-10 md:flex-row md:items-center md:justify-between md:py-14" data-testid="outcomes-ip-strip">
                        <div className="flex items-center gap-6">
                            <span className="font-display text-[clamp(2.75rem,10vw,6rem)] font-extrabold leading-none tracking-tight text-sky">
                                IP
                            </span>
                            <div>
                                <p className="text-sm font-medium uppercase tracking-[0.14em] text-white md:text-lg">
                                    &amp; Patent Support
                                </p>
                                <p className="mt-2 max-w-md text-sm leading-relaxed text-sky/70">
                                    Research guidance and patent evaluation for student innovation —
                                    because some four-year projects deserve protection.
                                </p>
                            </div>
                        </div>
                        <ArrowUpRight className="h-8 w-8 shrink-0 text-sky transition-transform duration-500 group-hover:translate-x-1 group-hover:-translate-y-1" />
                    </div>
                </Fade>
            </div>
        </section>
    );
}
